export const SET_COMPANY_DATA = 'set/COMAPANY_DATA';
// export const SET_SUPPLIERDATA = 'set/SUPPLIERDATA';
// export const SET_CATEGORYDATA = 'set/CATEGORYDATA';
// export const SET_MEASURESDATA = 'set/MEASURESDATA';
export const SET_PROFILEDATA = 'set/PROFILEDATA';
